(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-Subscription-Widget"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionWidget extends HTMLElement {
    connectedCallback() {
      this.cards = this.querySelectorAll('[data-plan-type]');
      this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
      this.ctaButton = this.querySelector('[data-add-to-cart]');

      for (const card of this.cards) {
        card.addEventListener('click', () => this.#selectPlan(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.#selectPlan(card);
          }
        });
      }

      /* Default to 90-day */
      const defaultCard = this.querySelector('[data-plan-type="90-day"]');
      if (defaultCard) {
        this.#selectPlan(defaultCard);
      }
    }

    #selectPlan(selectedCard) {
      for (const card of this.cards) {
        card.setAttribute('aria-checked', 'false');
        const radio = card.querySelector('.sub-widget__radio');
        if (radio) {
          radio.classList.remove('sub-widget__radio--checked');
        }
      }

      selectedCard.setAttribute('aria-checked', 'true');
      const radio = selectedCard.querySelector('.sub-widget__radio');
      if (radio) {
        radio.classList.add('sub-widget__radio--checked');
      }

      const planId = selectedCard.dataset.sellingPlanId;
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = planId || '';
      }

      /* Dispatch event for the product form */
      this.dispatchEvent(new CustomEvent('subscription:plan-changed', {
        detail: {
          sellingPlanId: planId || null,
          planType: selectedCard.dataset.planType
        },
        bubbles: true
      }));
    }
  }

  if (!customElements.get('subscription-widget')) {
    customElements.define('subscription-widget', SubscriptionWidget);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-landing"] && !Shopify.designMode) return;
  try {
    
  /* ─── SMOOTH SCROLL FOR CTA LINKS ─── */
  /* Handles scrolling to the native Shopify product section */
  document.querySelectorAll('.cl a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href').slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-preworkout-listicle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.getElementById('carbonStickyBar');
    if (!bar) return;
    var shown = false;
    window.addEventListener('scroll', function() {
      var scrolled = window.scrollY || window.pageYOffset;
      if (scrolled > 400 && !shown) {
        bar.classList.add('is-visible');
        shown = true;
      } else if (scrolled <= 400 && shown) {
        bar.classList.remove('is-visible');
        shown = false;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_page_header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function handlePphCtaClick(event) {
      const cta = event.currentTarget;
      const href = cta.getAttribute('href') || '';
      const hashIndex = href.indexOf('#');

      // No anchor in this link at all, e.g. a link straight to /cart.
      // Let the browser handle it normally.
      if (hashIndex === -1) return;

      const targetId = href.slice(hashIndex + 1);

      // Href is just "#" with nothing after it (the unset default value).
      // Treat it as a disabled link rather than jumping to the top of the page.
      if (!targetId) {
        event.preventDefault();
        return;
      }

      // Everything before the "#", with any stray trailing "?" trimmed off,
      // so a link like ".../page?#Target" still compares correctly.
      const pagePart = href.slice(0, hashIndex).replace(/\?$/, '');
      const currentPage = window.location.origin + window.location.pathname;
      const isSamePage = pagePart === '' || pagePart === currentPage;
      const target = document.getElementById(targetId);

      if (isSamePage && target) {
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#' + targetId);
        }
        return;
      }

      // Points to a different page, or the target is not on this page.
      // Fall through and let the browser navigate there as a normal link.
    }

    for (const cta of document.querySelectorAll('.pph__cta')) {
      cta.addEventListener('click', handlePphCtaClick);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-lander"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sticky = document.getElementById('tl-sticky');
    var hero = document.getElementById('tl-hero');
    if (!sticky || !hero) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var heroBottom = hero.getBoundingClientRect().bottom;
          if (heroBottom < 0) {
            sticky.classList.add('tl-sticky--visible');
          } else {
            sticky.classList.remove('tl-sticky--visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tl-visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.tl-fade').forEach(function(el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTrack(track) {
      let ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (maxScroll > 0 && track.scrollLeft >= maxScroll - 2) {
            track.scrollLeft = 0;
          }
          ticking = false;
        });
      }, { passive: true });

      const videos = track.querySelectorAll('.ugc__video');

      if (!('IntersectionObserver' in window)) {
        for (const video of videos) {
          const p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        for (const entry of entries) {
          const video = entry.target;
          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        }
      }, { threshold: 0.6 });

      for (const video of videos) {
        observer.observe(video);
      }
    }

    for (const track of document.querySelectorAll('.ugc__track')) {
      initTrack(track);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
